import React, { useEffect } from 'react';
import EventPeopleTrainers from './EventPeopleTrainers';
import EventPeopleAttendees from './EventPeopleAttendees';
import EventPeopleCsSpecialist from './EventPeopleCsSpecialist';
import {
  checkHasEventTrainerPermissions,
  checkHasEditEventPermissions,
  getClientSubdomain
} from '../../../../utils';
import useDataTrainers from '../../../../dataHooks/useDataTrainers';

const getUniqueTrainers = (trainers) => {
  const trainersMap = {}

  return trainers.filter(t => { 
    if (trainersMap[t.requestedTrainer]) {
      return false
    }
    trainersMap[t.requestedTrainer] = t;
    return true;
  });
}

export default ({
  eventData = {},
  isStarSubdomain
}) => {
  const hasEventTrainerPermissions = (checkHasEventTrainerPermissions() || checkHasEditEventPermissions())

  const isStar = getClientSubdomain() === 'star'

  const {
    isLoading,
    trainers,
    fetchTrainers
  } = useDataTrainers()

  const trainersUnique = getUniqueTrainers(trainers)
  const trainersLead = []
  const trainersNonLead = []
  trainersUnique.forEach(t => {
    if (isStar && Boolean(t.isLead) === true) {
      trainersLead.push(t)
    } else {
      trainersNonLead.push(t)
    }
  })

  const onTrainersUpdated = (data) => {
    fetchTrainers(data)
  }

  useEffect(() => {
    fetchTrainers({ eventId : eventData.id })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventData.id])

  return (
    <div>
    {
      isStarSubdomain &&
      <EventPeopleTrainers eventData={eventData} trainers={trainersLead} isLoading={isLoading} onTrainersUpdated={onTrainersUpdated} isLead={true} />
    }
    <EventPeopleTrainers eventData={eventData} trainers={trainersNonLead} isLoading={isLoading} onTrainersUpdated={onTrainersUpdated} />
    {
      isStarSubdomain && hasEventTrainerPermissions &&
      <EventPeopleCsSpecialist eventData={eventData} />
    }
    <EventPeopleAttendees eventData={eventData} />
    </div>
  )
}